import $ from "../../global/util";

export default {
  GET_NOTIFICATIONS: {
    PATH: "/devices",
  },
};
